module.exports = __webpack_public_path__ + "img/jiangyin.0b3e6fd.png";